export const Enums = {
    status: {
        journey: [
            {value: 'active', label: 'Active'},
            {value: 'inactive', label: 'Inactive'},
            {value: 'idle', label: 'Idle', isDisabled: true},
            {value: 'expired', label: 'Expired', isDisabled: true},
            {value: 'processing', label: 'Processing', isDisabled: true},
            {value: 'scheduled', label: 'Scheduled', isDisabled: true},
            {value: 'on_demand', label: 'On demand'},
        ],
        landing: [
            {value: 'active', label: 'Active'},
            {value: 'draft', label: 'Draft'},
            {value: 'maintenance', label: 'Maintenance'}
        ],
        accounts: [
            {value: 'active', label: 'Active'},
            {value: 'suspended', label: 'Suspended'}
        ]
    },
    channels: [
        {value: 'sms', label: 'Sms'},
        {value: 'email', label: 'Email'},
        {value: 'webservice', label: 'Web Service'},
    ]
}


export const DataDrivenSlug = 'data_driven'
export const SingleShootSlug = 'single_shoot'
export const ApiEventSlug = 'api_event'
export const SegmentSlug = 'segment'
export const LookupSlug = 'lookup'
export const RobinsonSlug = 'robinson'
export const SmsSlug = 'sms'
export const EmailSlug = 'email'
export const WhatsappSlug = 'whatsapp'

export const CounterSlug = 'counter'
export const EventSlug = 'event'
export const SftpSlug = 'sftp'
export const WebserviceSlug = 'web_service'
export const DashboardBarWidth = 20;


export const DataDrivenLabel = 'Data Driven'
export const SingleShootLabel = 'Single Shoot'
export const ApiEventLabel = 'Api Event'
export const SegmentLabel = 'Segment'
export const LookupLabel = 'Lookup'
export const RobinsonLabel = 'Robinson'
export const SmsLabel = 'Sms'
export const EmailLabel = 'Email'
export const WhatsappLabel = 'Whatsapp'

export const CounterLabel = 'Counter'
export const EventLabel = 'Event'
export const SftpLabel = 'Sftp'
export const WebserviceLabel = 'Web Service'


export const InfoLabel = 'Info'
export const AuthLabel = 'Auth'
export const SettingsLabel = 'Settings'
